import { JCA_EXPORT_COLUMNS } from '../constants'

export const jcaExportDataPreparation = ({ data, combos, intl }) => {
  return data.map((item) => {
    const formattedText = {}
    JCA_EXPORT_COLUMNS.forEach((column) => {
      if (column.field === 'tipo_documento') {
        formattedText[column.field] = 'JCA'
      }
      if (column.type === 'date' && item[column.field]) {
        const date = new Date(item[column.field])
        const formatedDate = intl.formatDate(date)

        formattedText[column.field] = formatedDate
      }
      if (column.field === 'estado') {
        const estadoValue =
          combos.estados_jca_readonly.data?.find((estado) => estado.key === item[column.field])
            ?.value || ''
        formattedText[column.field] = estadoValue
      }
      if (column.field === 'tipo_gas' && item[column.field]) {
        let tipoGas = ''
        if (item[column.field] === 'GAS NATURAL') {
          tipoGas = 'GN'
        } else {
          tipoGas = 'GLP'
        }

        formattedText[column.field] = tipoGas
      }
    })
    return {
      ...item,
      ...formattedText,
    }
  })
}
